// extracted by mini-css-extract-plugin
module.exports = {"link":"WidgetMenuItem_link__3Pcpo","active":"WidgetMenuItem_active__1anuJ"};